'use strict';

const { h } = require('phy');
const { hydrate } = require('@grpn/hydration');

const RedemptionHeader = require('./redemption-header');
const RedemptionCode = require('./redemption-code');
const RedemptionTerms = require('./redemption-terms');
const RedemptionRedirect = require('./redemption-redirect');
const OfferFinancialTerms = require('../../shared/views/offer/offer-financial-terms');

function RedemptionModalRedeem({
  offerId,
  offerTitle,
  offerCode,
  merchantId,
  merchantMedia,
  merchantName,
  expiryDateTime,
  termsAndConditions,
  financialTerms,
  routes,
  referralSource,
  directRedemption,
}) {
  return h(
    '.redemption-modal-redeem',
    {
      'data-bhw': 'RedemptionModal',
    },
    [
      h(RedemptionHeader, {
        routes,
        merchantId,
        merchantMedia,
        merchantName,
        offerTitle,
      }),
      h('.redemption-modal-content', [
        h(OfferFinancialTerms, {
          terms: financialTerms,
          className: 'redemption-modal-financial',
        }),
        h(RedemptionCode, { offerCode }),
        h(RedemptionRedirect, {
          routes,
          offerId,
          referralSource,
          directRedemption,
        }),
      ]),
      h(
        '.redemption-modal-footer',
        h(RedemptionTerms, { termsAndConditions, expiryDateTime })
      ),
    ]
  );
}

module.exports = hydrate('RedemptionModalRedeem', RedemptionModalRedeem);
